import { render } from "./StakeDashboard.vue?vue&type=template&id=2a8f4e65"
import script from "./StakeDashboard.vue?vue&type=script&lang=js"
export * from "./StakeDashboard.vue?vue&type=script&lang=js"

import "./StakeDashboard.vue?vue&type=style&index=0&id=2a8f4e65&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/StakeDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a8f4e65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a8f4e65', __exports__)) {
    api.reload('2a8f4e65', __exports__)
  }
  
  module.hot.accept("./StakeDashboard.vue?vue&type=template&id=2a8f4e65", () => {
    api.rerender('2a8f4e65', render)
  })

}


export default __exports__